export default __webpack_public_path__ + "0b6f40ebd4f4bdd1c4d340afab1ab0d8.png";